module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shirt_config"
  }, [_c('div', {
    staticClass: "shirt_measurements"
  }, [_c('h4', {
    staticClass: "shirt_measurements_header"
  }, [_vm._v("Shirt Measurements")]), _vm._v(" "), _c('div', {
    staticClass: "measures-container",
    style: ({
      'background-image': ("url(" + (require('../../assets/shirt.gif')) + ")")
    })
  }, [_c('garment-config', {
    staticClass: "demi-poitrine",
    attrs: {
      "smart": _vm.smartMeasures.chest,
      "smart-measurements": _vm.smartMeasurements.chest,
      "init-garment": _vm.initGarmentMeasures.chest,
      "label": "1/2 POITRINE",
      "name": "demi_poitrine"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "demi-taille",
    attrs: {
      "smart": _vm.smartMeasures.waist,
      "smart-measurements": _vm.smartMeasurements.waist,
      "init-garment": _vm.initGarmentMeasures.waist,
      "label": "1/2 TAILLE",
      "name": "demi_taille"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "demi-bassin",
    attrs: {
      "smart": _vm.smartMeasures.hips,
      "smart-measurements": _vm.smartMeasurements.hips,
      "init-garment": _vm.initGarmentMeasures.hips,
      "label": "1/2 BASSIN",
      "name": "demi_bassin"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config-2', {
    staticClass: "demi-poignets-boutonnes",
    attrs: {
      "smart": _vm.smartMeasures.cuff,
      "smart-measurements": _vm.smartMeasurements.cuff,
      "init-garment-left": _vm.initGarmentMeasures.wristl,
      "init-garment-right": _vm.initGarmentMeasures.wristr,
      "label": "1/2 POIGNETS BOUTONNES",
      "name": "wrist"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config-2', {
    staticClass: "longueur-manche",
    attrs: {
      "smart": _vm.smartMeasures.sleeve_length,
      "smart-measurements": _vm.smartMeasurements.sleeve_length,
      "init-garment-left": _vm.initGarmentMeasures.sleevel,
      "init-garment-right": _vm.initGarmentMeasures.sleever,
      "label": "LONGUEUR MANCHE",
      "name": "sleeve"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "carrure-dos",
    attrs: {
      "smart": _vm.smartMeasures.back_shoulder,
      "smart-measurements": _vm.smartMeasurements.back_shoulder,
      "init-garment": _vm.initGarmentMeasures.shoulders,
      "label": "CARRURE DOS",
      "name": "shoulders"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "demi-biceps",
    attrs: {
      "smart": _vm.smartMeasures.biceps,
      "smart-measurements": _vm.smartMeasurements.biceps,
      "init-garment": _vm.initGarmentMeasures.biceps,
      "label": "1/2 BICEPS",
      "name": "biceps"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "longueur-dos",
    attrs: {
      "smart": _vm.smartMeasures.back_length,
      "smart-measurements": _vm.smartMeasurements.back_length,
      "init-garment": _vm.initGarmentMeasures.back,
      "label": "LONGUEUR DOS",
      "name": "back"
    },
    on: {
      "config": _vm.set
    }
  }), _vm._v(" "), _c('garment-config', {
    staticClass: "tour-de-cou",
    attrs: {
      "smart": _vm.smartMeasures.collar_real,
      "smart-measurements": _vm.smartMeasurements.collar_real,
      "init-garment": _vm.initGarmentMeasures.neck,
      "label": "TOUR DE COU",
      "name": "neck"
    },
    on: {
      "config": _vm.set
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shirt_alternations"
  }, [_c('h4', [_vm._v("Shirt Alternations")]), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Sleeve Pleats")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sleevePleats),
      expression: "sleevePleats"
    }],
    staticClass: "ui dropdown selection",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "sleevePleats"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sleevePleats = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sleevePleatsOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value,
        "selected": option.value == '0' ? 'selected' : ''
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Head position")]), _vm._v(" "), _c('modifier', {
    staticClass: "modifier",
    attrs: {
      "init-val": _vm.encolure,
      "left-text": "Head forward",
      "right-text": "Straight back",
      "column": "headPosition"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.headPosition),
      callback: function($$v) {
        _vm.headPosition = $$v
      },
      expression: "headPosition"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Shoulder position")]), _vm._v(" "), _c('span', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shoulderPositionLR),
      expression: "shoulderPositionLR"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.shoulderPositionLR) ? _vm._i(_vm.shoulderPositionLR, null) > -1 : (_vm.shoulderPositionLR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shoulderPositionLR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.shoulderPositionLR = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.shoulderPositionLR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shoulderPositionLR = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("L+R")])]), _vm._v(" "), (_vm.shoulderPositionLR) ? _c('modifier', {
    attrs: {
      "init-val": _vm.pente_epaule_g,
      "slider-pops": [-0.5],
      "slider-valid-min": -2,
      "left-text": "Sloping",
      "right-text": "Square",
      "column": "shoulderPositionLeft"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.shoulderPositionLeft),
      callback: function($$v) {
        _vm.shoulderPositionLeft = $$v
      },
      expression: "shoulderPositionLeft"
    }
  }) : _c('div', {
    staticClass: "modifier-lr"
  }, [_c('modifier', {
    staticClass: "modifier-top",
    attrs: {
      "init-val": _vm.pente_epaule_g,
      "slider-pops": [-0.5],
      "slider-valid-min": -2,
      "main-label": "L",
      "left-text": "Sloping",
      "right-text": "Square",
      "column": "shoulderPositionLeft"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.shoulderPositionLeft),
      callback: function($$v) {
        _vm.shoulderPositionLeft = $$v
      },
      expression: "shoulderPositionLeft"
    }
  }), _vm._v(" "), _c('modifier', {
    staticClass: "modifier-bottom",
    attrs: {
      "init-val": _vm.pente_epaule_d,
      "slider-pops": [-0.5],
      "slider-valid-min": -2,
      "main-label": "R",
      "left-text": "Sloping",
      "right-text": "Square",
      "column": "shoulderPositionRight"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.shoulderPositionRight),
      callback: function($$v) {
        _vm.shoulderPositionRight = $$v
      },
      expression: "shoulderPositionRight"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Low Shoulder Back Only")]), _vm._v(" "), _c('span', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.penteDosLR),
      expression: "penteDosLR"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.penteDosLR) ? _vm._i(_vm.penteDosLR, null) > -1 : (_vm.penteDosLR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.penteDosLR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.penteDosLR = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.penteDosLR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.penteDosLR = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("L+R")])]), _vm._v(" "), (_vm.penteDosLR) ? _c('modifier', {
    attrs: {
      "slider-valid-min": -2,
      "slider-valid-max": 0,
      "init-val": _vm.pente_dos,
      "left-text": "Sloping",
      "column": "lowShoulderBackOnly"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.lowShoulderBackOnly),
      callback: function($$v) {
        _vm.lowShoulderBackOnly = $$v
      },
      expression: "lowShoulderBackOnly"
    }
  }) : _c('div', {
    staticClass: "modifier-lr"
  }, [_c('modifier', {
    staticClass: "modifier-top",
    attrs: {
      "slider-valid-min": -2,
      "slider-valid-max": 0,
      "init-val": _vm.pente_dos,
      "main-label": "L",
      "left-text": "Sloping",
      "column": "lowShoulderBackOnly"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.lowShoulderBackOnly),
      callback: function($$v) {
        _vm.lowShoulderBackOnly = $$v
      },
      expression: "lowShoulderBackOnly"
    }
  }), _vm._v(" "), _c('modifier', {
    staticClass: "modifier-bottom",
    attrs: {
      "slider-valid-min": -2,
      "slider-valid-max": 0,
      "init-val": _vm.pente_dos,
      "main-label": "R",
      "left-text": "Sloping",
      "column": "lowShoulderBackOnly"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.lowShoulderBackOnly),
      callback: function($$v) {
        _vm.lowShoulderBackOnly = $$v
      },
      expression: "lowShoulderBackOnly"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Stooped")]), _vm._v(" "), _c('modifier', {
    attrs: {
      "slider-valid-min": 0,
      "slider-valid-max": 1.5,
      "init-val": _vm.stooped,
      "column": "alterStooped"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.alterStooped),
      callback: function($$v) {
        _vm.alterStooped = $$v
      },
      expression: "alterStooped"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Armhole opening")]), _vm._v(" "), _c('modifier', {
    attrs: {
      "step": 1,
      "slider-valid-min": -2,
      "slider-valid-max": 2,
      "display-valid-min": -2,
      "display-valid-max": 2,
      "init-val": _vm.position_emmanchure,
      "left-text": "Smaller",
      "right-text": "Bigger",
      "column": "armholeOpening"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.armholeOpening),
      callback: function($$v) {
        _vm.armholeOpening = $$v
      },
      expression: "armholeOpening"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Front Yoke")]), _vm._v(" "), _c('modifier', {
    attrs: {
      "step": 0.3,
      "slider-valid-min": -0.9,
      "slider-valid-max": 0.9,
      "slider-display-min": -0.9,
      "slider-display-max": 0.9,
      "init-val": _vm.front_yoke,
      "left-text": "Smaller",
      "right-text": "Bigger",
      "column": "frontYoke"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.frontYoke),
      callback: function($$v) {
        _vm.frontYoke = $$v
      },
      expression: "frontYoke"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Front Chest")]), _vm._v(" "), _c('modifier', {
    attrs: {
      "slider-valid-min": -1,
      "slider-valid-max": 1,
      "init-val": _vm.petite_poitrine,
      "column": "frontChest"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.frontChest),
      callback: function($$v) {
        _vm.frontChest = $$v
      },
      expression: "frontChest"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Back Chest")]), _vm._v(" "), _c('modifier', {
    attrs: {
      "slider-valid-min": -1,
      "slider-valid-max": 1,
      "init-val": _vm.petite_carrure,
      "column": "backChest"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.backChest),
      callback: function($$v) {
        _vm.backChest = $$v
      },
      expression: "backChest"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Waist Allocation")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Total waist:")]), _vm._v(" " + _vm._s(_vm.totalWaist) + "--cm |\n        "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("In front:")]), _vm._v(" " + _vm._s(_vm.frontWaist) + "--cm |\n        "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("In back:")]), _vm._v(" " + _vm._s(_vm.backWaist) + "--cm\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.waistAllocation),
      expression: "waistAllocation"
    }],
    staticClass: "ui dropdown selection",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "waistAllocation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.waistAllocation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.waistAllocationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value,
        "selected": option.value == '0' ? 'selected' : ''
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Hips Forward")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('modifier', {
    attrs: {
      "step": 1,
      "slider-valid-min": 0,
      "slider-valid-max": 5,
      "slider-display-min": 0,
      "slider-display-max": 5,
      "init-val": _vm.repart_bassin,
      "column": "hipsForward"
    },
    on: {
      "modified": _vm.onMod
    },
    model: {
      value: (_vm.hipsForward),
      callback: function($$v) {
        _vm.hipsForward = $$v
      },
      expression: "hipsForward"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alt-flex row"
  }, [_c('span', {
    staticClass: "fieldname"
  }, [_vm._v("Long front only")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Longueur dos:")]), _vm._v(" " + _vm._s(_vm.backLength) + "--cm |\n        "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Front length:")]), _vm._v(" " + _vm._s(_vm.frontLength) + "--cm\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longFrontOnly),
      expression: "longFrontOnly"
    }],
    staticClass: "ui dropdown selection",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "longFrontOnly"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.longFrontOnly = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.longFrontOnlyOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value,
        "selected": option.value == '0' ? 'selected' : ''
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462fa268","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ShirtEdit.vue
// module id = 496
// module chunks = 1